document.addEventListener('click', function (e) {

  const swatch = e.target.closest('.swatch__button, .swatch__label');
  if (!swatch) return;
  // Wait for Shopify variant update
  setTimeout(() => {

    // Remove old Judge.me loader
    document
      .querySelectorAll('script[src*="cdn.judge.me/loader.js"]')
      .forEach(script => script.remove());

    // Reinsert loader with cache busting
    const script = document.createElement('script');
    script.src = 'https://cdn.judge.me/loader.js?v=' + new Date().getTime();
    script.async = false;

    document.head.appendChild(script);

    console.log('Judge.me loader reinserted');

  }, 800);

});
